export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-forrst-33251135d32433b72d4b43aebca3b918.svg";